module.exports = __webpack_public_path__ + "img/4.f42df2d5.webp";